import { useMutation } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface CreateFloatingContextSourceVariables {
  scheduleId: number
  sourceId: number | string
  sourceType: string
}

interface ScheduleContentContextSourceResponse {
  schedule_content_context_source: {
    id: number
    source_type: string
    source_id: number
    content_id: number | null
    created_at: string
    updated_at: string
  }
}

const createFloatingContextSource = async ({
  scheduleId,
  sourceId,
  sourceType,
}: CreateFloatingContextSourceVariables): Promise<number> => {
  const response = await sendToApi<ScheduleContentContextSourceResponse>(
    `/schedules/${scheduleId}/content_context_sources`,
    {
      method: 'POST',
      body: { source_id: sourceId, source_type: sourceType },
    },
  )

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to create context source')
  }

  return response.data.schedule_content_context_source.id
}

export const useCreateFloatingContextSource = () => {
  return useMutation<number, Error, CreateFloatingContextSourceVariables>(createFloatingContextSource)
}
